declare global {
  interface String {
    formatDatetimeStrToNaijaTime(): string;
    replaceZeroWith234(): string;
    capitalize(): string;
  }
  interface Object {
    capitalize(): string;
  }
  interface Number {
    formatNaira(): string;
  }
}

const capitalizeValue = (value: unknown): string => {
  if (typeof value === 'string' || value instanceof String) {
    if (value.length === 0) {
      return value.toString();
    }

    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }

  if (value && typeof value === 'object') {
    const errorMessage = (value as { message?: unknown; }).message;
    if (typeof errorMessage === 'string') {
      return capitalizeValue(errorMessage);
    }
  }

  return '';
};

// eslint-disable-next-line
Number.prototype.formatNaira = function (): string {
  return this.toLocaleString('en-NG', {
    style: 'currency',
    currency: 'NGN',
  });
};

// eslint-disable-next-line
String.prototype.formatDatetimeStrToNaijaTime = function (): string {
  const date = new Date(this as string);
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    timeZone: 'Africa/Lagos',
  } as Intl.DateTimeFormatOptions;

  return date.toLocaleString('en-NG', options);
};

// eslint-disable-next-line
String.prototype.replaceZeroWith234 = function (): string {
  if (this.startsWith('0')) {
    return '234' + this.slice(1);
  }
  return this.toString();
};

// eslint-disable-next-line
String.prototype.capitalize = function (): string {
  return capitalizeValue(this);
};

// eslint-disable-next-line
Object.defineProperty(Object.prototype, 'capitalize', {
  value: function (): string {
    return capitalizeValue(this);
  },
  configurable: true,
  writable: true,
});


export {};
